// @flow

import { createQcTicketActions } from './createQcTicketActionCreator';

const initialState = {
  fetching: null,
  fetched: null
};

const createQcTicketReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case createQcTicketActions.CREATE_QC_TICKET: {
      return Object.assign({}, state, action.payload);
    }

    default:
      return state;
  }
};

export default createQcTicketReducer;
